import { useTranslation } from 'react-i18next';

import { addAuditFilters, applyAuditFilterChange } from '@/domain/auditLog';

import FilterTextField from '../../FilterTextField';
import FilterMenu from '../FilterMenu';
import type { AuditFilterBindings } from '../filterBindings';
import { outcomeSections } from '../filterOptions';
import ScopePicker from '../ScopePicker';

import FilterGroup from './FilterGroup';
import PanelField from './PanelField';

interface WhereResultFiltersProps {
    bindings: AuditFilterBindings;
}

export default function WhereResultFilters({ bindings }: WhereResultFiltersProps) {
    const { filters, onChange, onType } = bindings;
    const { t } = useTranslation();

    return (
        <>
            <FilterGroup legend={t('auditLog.filters.group.where')}>
                <PanelField label={t('auditLog.filters.where')}>
                    {(labelId) => (
                        <ScopePicker
                            bindings={bindings}
                            label={t('auditLog.filters.where')}
                            labelledBy={labelId}
                        />
                    )}
                </PanelField>
            </FilterGroup>
            <FilterGroup legend={t('auditLog.filters.group.result')}>
                <PanelField label={t('auditLog.filters.outcome')}>
                    {(labelId) => (
                        <FilterMenu
                            label={t('auditLog.filters.outcome')}
                            labelledBy={labelId}
                            options={outcomeSections(t)}
                            selected={filters.outcome}
                            onChange={(outcome) =>
                                onChange(
                                    applyAuditFilterChange(filters, addAuditFilters({ outcome }))
                                )
                            }
                        />
                    )}
                </PanelField>
                <FilterTextField
                    field="statusCode"
                    label={t('auditLog.filters.statusCode')}
                    hint={t('auditLog.filters.statusCodeHint')}
                    filters={filters}
                    onType={onType}
                />
            </FilterGroup>
        </>
    );
}
